import {Constant} from './../../../../shared/constants/constant.class';
import {NotificationService} from './../../../../service/notification.service';
import {GeneralService} from './../../../../service/general-service';
import {AppConfigService} from './../../../../../app-config.service';
import {TableSelectionAbstract} from 'src/app/shared/component/table/table-selection.abstract';
import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import moment from 'moment';
import {DxDataGridComponent} from 'devextreme-angular';
import {Workbook} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {DateFormatPipe} from '../../../../shared/pipe/format-date.pipe';
import {saveAs} from 'file-saver-es';
import {Router} from '@angular/router';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent extends TableSelectionAbstract
  implements OnInit {
  orderTypeDatas: any[] = [];
  normalRangeDatas: any[] = [];
  totalToPay: 1;
  totalPaid: 1;
  filter: FormGroup;

  ///// helper /////
  loadingPay: boolean;
  loadingPaid: boolean;
  page: any;
  pageIndex = 1;
  pageSizeOption: any;
  defaultPageSize: any;

  form: FormGroup;
  formPaid: FormGroup;
  isVisibleUpdate = false;
  dataToPay: any;
  filterDataToPay: any;
  dataPaid: any;
  detailToPay: any;
  detailPaid: any;
  totalPrices = 0;
  lstBillPaid: any[] = [];
  searchText = '';
  currentBill: any = {
    specimenID: ''
  };
  selectedBills = [];
  currentBillPaid: any = {
    specimenID: ''
  };
  partners: any[] = [];
  checked: false;
  indeterminate = false;
  selectAll = false;
  allUser: any[] = [];
  grid1Height: string;
  grid2Height: string;
  currentFilter: any;

  // Thêm vào phần khai báo biến
  selectedDetailPaidIds: number[] = [];
  isVisibleExpenseModal = false;
  expenseReason = '';
  loadingCreateExpense = false;


  @ViewChild('gridNeed') dataGrid1: DxDataGridComponent;
  @ViewChild('gridPaid') dataGrid2: DxDataGridComponent;

  constructor(
    private configService: AppConfigService,
    private generalService: GeneralService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private dateFormatPipe: DateFormatPipe,
    private router: Router
  ) {
    super('id');

    const startOfMonth = moment().startOf('month').toDate();
    console.log('startOfMonth', startOfMonth);
    this.form = this.fb.group({
      partnerId: [null],
      fromDate: [startOfMonth],
      toDate: [null],
      specimenID: [null],
      userTakenName: [null]
    });
    this.formPaid = this.fb.group({
      partnerId: [null],
      fromDate: [null],
      toDate: [null],
      specimenID: [null]
    });
    this.filter = this.fb.group({
      search: [null],
    });
  }

  selectSingleRow(key, preserve) {
    if (!this.dataGrid1.instance.isRowSelected(key)) {
      this.dataGrid1.instance.selectRows([key], preserve);
    }
  }

  ngOnInit(): void {
    this.pageSizeOption = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPageSize = 10000;
    this.initTableHeight(1200);
    this.getBillToPay();
    this.getBillPaid();
    this.getPartners();
    this.getAllUser();
    this.calculateGridHeight();
  }

  getAllUser() {
    this.generalService.getAllUser().subscribe((res) => {
      if (res !== null) {
        this.allUser = res.filter(el => el.staffCode != null && el.staffCode !== '');
      }
    });
  }

  getPartners() {
    this.generalService.getListPartner().subscribe((res) => {
      if (res !== null) {
        this.partners = res;
      }
    });
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  actionDetailToPay = (e: any) => {
    console.log(e.row.data);
    this.selectDetailToPay(e.row.data);
    /*this.router.navigate(['/mvp/add', e.row.data.id]);
    e.event.preventDefault();*/
    // this.router.navigate([`/mvp/edit/${e.row.data.id}`]);
  };

  getBillToPay() {
    this.loadingPay = true;
    const payload = {
      ...this.form.value,
      pageSize: this.defaultPageSize,
      page: this.pageIndex,
    };

    if (this.form.value) {
      if (this.form.value.fromDate) {
        payload.fromDate = this.form.value.fromDate;
      }
      if (this.form.value.toDate) {
        payload.toDate = this.form.value.toDate;
      }
      if (this.form.value.assignToUserId) {
        payload.specimenID = this.form.value.specimenID;
      }
      if (this.form.value.partnerId) {
        payload.partnerId = this.form.value.partnerId;
      }
      if (this.form.value.specimenID) {
        payload.specimenID = this.form.value.specimenID;
      }
      if (this.form.value.userTakenName) {
        payload.userTakenName = this.form.value.userTakenName;
      }

      this.generalService.getBillToPay(payload).subscribe(res => {
        if (res !== null) {
          this.totalToPay = res.total;
          this.dataToPay = res.data;
          this.filterDataToPay = res.data;
          res.data.forEach(item => {
            item.discountPaymentTypeText = item.discountPaymentType === 2 ? 'CK sau' : 'CK trực tiếp';
            item.sid = moment(item.createdDate).format('DDMMYY') + '-' + item.specimenID;
          });
          console.log('bill to pay', this.dataToPay);
          this.loadingPay = false;
          this.detailToPay = this.dataToPay.find(en => en.specimenID === this.currentBill.specimenID)?.details;
        }
      }, error => {

      });
    }
  }

  getBillPaid() {
    this.loadingPaid = true;
    const payload = {
      ...this.form.value,
      pageSize: this.defaultPageSize,
      page: this.pageIndex,
    };

    if (this.form.value) {
      if (this.form.value.fromDate) {
        payload.fromDate = this.form.value.fromDate;
      }
      if (this.form.value.toDate) {
        payload.toDate = this.form.value.toDate;
      }
      if (this.form.value.assignToUserId) {
        payload.specimenID = this.form.value.specimenID;
      }
      if (this.form.value.partnerId) {
        payload.partnerId = this.form.value.partnerId;
      }
      if (this.form.value.specimenID) {
        payload.specimenID = this.form.value.specimenID;
      }

      this.generalService.getBillPaid(payload).subscribe(res => {
        if (res !== null) {
          this.totalPaid = res.total;
          this.dataPaid = res.data;
          this.dataPaid.forEach(item => {
            item.sid = moment(item.createdDate).format('DDMMYY') + '-' + item.specimenID;
          });
          console.log('bill paid', this.dataPaid);
          if (this.currentBill) {
            this.loadingPaid = false;
            this.currentBillPaid.specimenID = this.currentBill.specimenID;
            this.detailPaid = this.dataPaid.find(en => en.specimenID === this.currentBill.specimenID)?.details;
          }
        }
      }, error => {

      });
    }
  }

  onQueryParamsChangePay(params): void {
    const {pageSize, pageIndex, sort, filter} = params;
    this.pageIndex = params.pageIndex;
    this.defaultPageSize = params.pageSize;
    const currentSort = sort.find((item) => item.value !== null);
    this.getBillToPay();
  }

  onQueryParamsChangePaid(params): void {
    const {pageSize, pageIndex, sort, filter} = params;
    this.pageIndex = params.pageIndex;
    this.defaultPageSize = params.pageSize;
    const currentSort = sort.find((item) => item.value !== null);
    this.getBillPaid();
  }

  doSearchPay() {
    // this.searchText = this.searchText.trim().toLowerCase();
    // this.filterDataToPay = this.dataToPay.filter(en => en.specimenID.trim().toLowerCase().includes(this.searchText));
    this.pageIndex = 1;
    this.getBillToPay();
    this.getBillPaid();
  }

  doSearchPaid() {
    this.pageIndex = 1;
  }

  clearSearch() {
    this.form.reset();
    this.getBillPaid();
    this.getBillToPay();
    this.currentBill.specimenID = '';
    this.currentBillPaid.specimenID = '';
  }

  selectData(data) {
    if (this.mapOfCheckedId[data.orderDetailId]) {
      this.lstBillPaid.push(data.orderDetailId);
      this.totalPrices += data.price;
    } else {
      this.totalPrices -= data.price;
      this.lstBillPaid = this.lstBillPaid.filter(item => item.orderId !== data.id);
    }
  }

  selectDetailToPay(data) {
    // alert('vao day');
    this.currentBillPaid = {};
    // this.detailPaid = [];
    this.currentBill = data;
    this.detailToPay = this.dataToPay.find(en => en.specimenID === data.specimenID).details;

    this.detailToPay.forEach(en => {
      en.id = en.orderDetailId;
    });
    /*if (this.dataPaid.filter(el => el.specimenID === data.specimenID).length !== 0) {
      this.currentBillPaid.specimenID = data.specimenID;
      this.detailPaid = this.dataPaid.find(
        (en) => en.specimenID === data.specimenID
      )?.details;
    }*/

  }

  selectDetailPaid(data) {
    this.currentBill = {};
    // this.detailToPay = [];
    this.currentBillPaid = data;
    this.detailPaid = this.dataPaid.find(en => en.specimenID === data.specimenID).details;

    this.currentBill.specimenID = data.specimenID;
    /* this.detailToPay = this.dataToPay.find(
       (en) => en.specimenID === data.specimenID
     )?.details;*/
    console.log(this.currentBill.specimenID);
  }

  paidMoney() {
    const payload = {
      amountOfMoney: this.totalPrices,
      orderDetailIds: this.lstBillPaid
    };
    this.generalService.paidMoney(payload).subscribe(res => {
      if (!res.isValid) {
        this.notificationService.showNotification(Constant.ERROR, res.errors[0].errorMessage);
      } else {
        this.lstBillPaid = [];
        this.totalPrices = 0;
        this.checkAllRow(false);
        this.resetTable();
        this.notificationService.showNotification(Constant.SUCCESS, 'Thanh toán thành công');
      }
    }, error => {

    });
  }

  resetTable() {
    this.getBillToPay();
    this.getBillPaid();
  }

  checkedAllEvent() {
    this.lstBillPaid = this.getCheckedIdList();
    if (this.lstBillPaid.length !== 0) {
      this.totalPrices = this.currentBill.money;
    } else {
      this.totalPrices = 0;
    }
  }

  printPhieuThu(showCK = false) {
    const data = this.currentBill;
    console.log(data.details[0].orderID);
    data.id = data.details[0].orderID;
    let params = '?id=';
    params += data.id;
    params = params + '&';
    params = params.substring(0, params.length - 1);
    if (showCK) {
      params += '&report=PhieuThuTienCKTong';
    } else {
      params += '&report=PhieuThuTien';
    }
    // window.open(window.location.origin + '/order-result' + params, '_blank');
    window.open(this.configService.getConfig().api.reportUrl + '/BridgeXLSDownload.aspx' + params, '_blank');
    console.log(params);
  }

  calculateGridHeight() {
    const filterTop = document.getElementsByClassName('div-action-top')[0];
    let filterHeight = filterTop ? filterTop.clientHeight : 0;

    const filterBottom = document.getElementsByClassName('div-action-bottom')[0];
    filterHeight += filterBottom ? filterBottom.clientHeight : 0;
    const windowHeight = window.innerHeight;

    const gridHeight = window.innerHeight - filterHeight + 10;
    this.grid1Height = `${gridHeight / 2}px`;
    this.grid2Height = `${gridHeight / 2}px`;
    console.log(this.grid1Height, this.grid2Height);
  }

  onNeedSelectionChanged($event: any) {
    console.log($event);
    this.selectedBills = $event.selectedRowKeys;
    console.log(this.selectedBills);
    return;
    this.selectDetailToPay($event.selectedRowKeys[0]);
    console.log($event.selectedRowKeys[0]);
  }

  onPaidSelectionChanged($event: any) {
    console.log($event);
    if ($event.selectedRowKeys[0]) {
      this.selectDetailPaid($event.selectedRowKeys[0]);
      console.log($event.selectedRowKeys[0]);
    }
  }

  onGridNeedPaidExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    const from = this.dateFormatPipe.transformFull(this.form.value.fromDate, Constant.DATE_FMT_STR);
    const to = this.dateFormatPipe.transformFull(this.form.value.toDate, Constant.DATE_FMT_STR);
    let dateStr = from === to ? from : (from + '_' + to);
    if (!to) {
      dateStr = from;
    }
    const fileName = `Phieu_chua_thanh_toan_${dateStr}`;
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName + '.xlsx');
      });
    });
    e.cancel = true;
  }

  onGridPaidExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    const from = this.dateFormatPipe.transformFull(this.form.value.fromDate, Constant.DATE_FMT_STR);
    const to = this.dateFormatPipe.transformFull(this.form.value.toDate, Constant.DATE_FMT_STR);
    let dateStr = from === to ? from : (from + '_' + to);
    if (!to) {
      dateStr = from;
    }
    const fileName = `Phieu_da_thanh_toan_${dateStr}`;
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName + '.xlsx');
      });
    });
    e.cancel = true;
  }

  exportNeedData() {
    this.dataGrid1.instance.exportToExcel(false);
  }

  exportPaidData() {
    this.dataGrid2.instance.exportToExcel(false);
  }

  printPhieuThanhToan(showCK: boolean, onlyTotalDiscount = false) {
    const data = this.currentBillPaid;
    console.log(data.details[0].orderID);
    data.id = data.details[0].orderID;
    let params = '?id=';
    params += data.id;
    params = params + '&';
    params = params.substring(0, params.length - 1);
    if (onlyTotalDiscount) {
      params += '&report=PhieuThuTienCKTong';
    } else {
      params += '&report=PhieuThuTien';
    }
    if (showCK === false) {
      params += '&showCK=false';
    }
    // window.open(window.location.origin + '/order-result' + params, '_blank');
    window.open(this.configService.getConfig().api.reportUrl + '/BridgeXLSDownload.aspx' + params, '_blank');
    console.log(params);
  }

  createBilling() {
    const orderDetailIds = this.selectedBills.map((en => en.details.map(child => child.orderDetailId)));
    let joinedIds = [];
    orderDetailIds.forEach(ids => {
      joinedIds = joinedIds.concat(ids);
    });
    const payload = {
      amountOfMoney: 0,
      orderDetailIds: joinedIds
    };

    this.generalService.createBillingWeb(payload).subscribe(res => {
      if (!res.isValid) {
        this.notificationService.showNotification(Constant.ERROR, res.errors[0].errorMessage);
      } else {
        this.currentBill.specimenID = '';
        this.getBillToPay();
        this.notificationService.showNotification(Constant.SUCCESS, 'Nộp tiền thành công');
        this.dataGrid1.instance.clearSelection();
      }
    }, error => {

    });
  }

  // Thêm method mở modal
  openExpenseModal() {
    this.expenseReason = '';
    this.isVisibleExpenseModal = true;
  }

  // Thêm method gọi API tạo phiếu chi
  createExpense() {
    if (!this.expenseReason || !this.expenseReason.trim()) {
      this.notificationService.showNotification(Constant.ERROR, 'Vui lòng nhập lý do');
      return;
    }
    this.loadingCreateExpense = true;
    const payload = {
      orderDetailIds: this.selectedDetailPaidIds,
      reasons: this.expenseReason.trim()
    };
    this.generalService.createExpense(payload).subscribe(res => {
      this.loadingCreateExpense = false;
      if (!res.isValid) {
        this.notificationService.showNotification(Constant.ERROR, res.errors[0].errorMessage);
      } else {
        this.isVisibleExpenseModal = false;
        this.selectedDetailPaidIds = [];
        this.notificationService.showNotification(Constant.SUCCESS, 'Tạo phiếu chi thành công');
        this.getBillPaid();
      }
    }, error => {
      this.loadingCreateExpense = false;
      this.notificationService.showNotification(Constant.ERROR, 'Có lỗi xảy ra');
    });
  }

  // Màu row + block checkbox cho row đã xuất toán
  onDetailPaidCellPrepared(e: any) {
    if (e.rowType !== 'data') {
      return;
    }

    if (e.data.isExpensePaid) {
      // Màu nền xanh nhạt toàn row
      e.cellElement.style.backgroundColor = '#f6ffed';
      e.cellElement.style.color = '#8c8c8c';
      e.cellElement.style.textDecoration = 'line-through';

      // Block checkbox ở cột selection
      if (e.column.type === 'selection') {
        const checkbox = e.cellElement.querySelector('.dx-checkbox');
        if (checkbox) {
          checkbox.style.pointerEvents = 'none';
          checkbox.style.opacity = '0.3';
        }
      }
    }
  }

  // Lọc bỏ những row isExpensePaid khi selection thay đổi
  // tslint:disable-next-line:adjacent-overload-signatures
  onDetailPaidSelectionChanged($event: any) {
    // Lọc ra chỉ những row chưa xuất toán
    const validSelected = $event.selectedRowKeys.filter(
      (row: any) => !row.isExpensePaid
    );

    // Nếu có row không hợp lệ được chọn → deselect ngay
    if (validSelected.length !== $event.selectedRowKeys.length) {
      $event.component.selectRows(validSelected, false);
      return;
    }

    this.selectedDetailPaidIds = validSelected.map(
      (row: any) => row.orderDetailId
    );
  }
  calculateExpensePaidSummary = (options: any) => {
    if (options.name === 'expensePaidTotal' || options.name === 'expenseRemaining') {
      switch (options.summaryProcess) {
        case 'start':
          options.totalValue = 0;
          break;
        case 'calculate':
          if (options.name === 'expensePaidTotal' && options.value?.isExpensePaid) {
            options.totalValue += options.value.price ?? 0;
          }
          if (options.name === 'expenseRemaining' && !options.value?.isExpensePaid) {
            options.totalValue += options.value.price ?? 0;
          }
          break;
      }
    }
  }
}
